import React from 'react'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import T from 'i18n-react'
import Icon from 'material-ui/Icon'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'

import { Link, withRouter } from 'react-router-dom'
import Messenger from '../messenger'

import { inject, observer } from 'mobx-react'
import { withLayoutAdmin } from '../../utils/hoc'
import NewExampleForm from '../newexampleform'
import NewCollectionForm from '../newcollectionform'
import Tabs, { Tab } from 'material-ui/Tabs'
import { withCookies, Cookies } from 'react-cookie'


@inject('admin','store') @observer
class LayoutAdmin extends React.Component {
  render () {
    const { classes,admin } = this.props
    return (
     <div>
      <AppBar position="fixed">
       <Toolbar>
        <Typography type="title" color="inherit" className="admin-appbar-title">
         {T.translate("admin.title")}
        </Typography>
        <Button raised dense color="secondary" onClick={this.logout}> {T.translate("admin.logout")} </Button>
       </Toolbar>
       <div className={classes.makeScrollable}>
        <Link to="inbox" className="unstyle-a"><Button color="inherit"> {T.translate("admin.inbox.title")} </Button></Link>
        <Link to="users" className="unstyle-a"><Button color="inherit"> {T.translate("admin.users")} </Button></Link>
        <Link to="settings" className="unstyle-a"><Button color="inherit"> {T.translate("admin.settings.title")} </Button></Link>
        <Link to="welcomepagesettings" className="unstyle-a"><Button color="inherit"> {T.translate("admin.wpSettings.title")} </Button></Link>
        <Link to="impressumconfig" className="unstyle-a"><Button color="inherit"> {T.translate("impressum.title")} </Button></Link>
       </div>
      </AppBar>
      <div id="admin-content" className={classes.content}>
       {this.props.children}
      </div>
      <Messenger />
      <ExampleFormConfigurer />
      <CollectionFormConfigurer />
     </div>
    )
  }

  componentWillMount () {
    if (!this.props.admin.hasMetaData) {
      this.props.admin.hasMetaData = true
      this.props.store.getAllMetadata()
    }
  }

  logout = () => {
    const { cookies } = this.props
    this.props.admin.logout(this.props.history,cookies)
  }

}


@inject('admin','store') @observer
class ExampleFormConfigurer extends React.Component {
  render () {
    const { admin,store } = this.props
    let label = ""

    if (admin.exampleForm.asUpdate) {
      label = T.translate("newexampleform.asUpdate")
    }

    else if (admin.exampleForm.asAcceptDecline) {
      label = T.translate("newexampleform.asAcceptDecline")
    }

    else if (admin.exampleForm.asDeleteRestore) {
      label = T.translate("newexampleform.asDeleteRestore")
    }

    return (
      <NewExampleForm
       label={label}
       example={admin.exampleForm.currentExample}
       lehrplan={store.lehrplan}

       asUpdate={admin.exampleForm.asUpdate}
       sendUpdate={admin.inbox.updateDeadlink}

       asDeleteRestore={admin.exampleForm.asDeleteRestore}
       sendPermDelete={admin.inbox.deleteItemPerm}
       sendRestore={admin.inbox.restoreItem}

       asAcceptDecline={admin.exampleForm.asAcceptDecline}
       sendAccept={admin.inbox.acceptExample}
       sendDecline={admin.inbox.declineExample}
      />
    )
  }
}

@inject('admin','store') @observer
class CollectionFormConfigurer extends React.Component {
  render () {
    const { admin,store } = this.props
    let label = ""

    if (admin.collectionForm.asUpdate) {
      label = T.translate("newexampleform.asUpdate")
    }

    else if (admin.collectionForm.asAcceptDecline) {
      label = T.translate("newexampleform.asAcceptDecline")
    }

    else if (admin.collectionForm.asDeleteRestore) {
      label = T.translate("newexampleform.asDeleteRestore")
    }

    return (
      <NewCollectionForm
       label={label}
       collection={admin.collectionForm.currentCollection}

       asDeleteRestore={admin.collectionForm.asDeleteRestore}
       sendPermDelete={admin.inbox.deleteCollectionPerm}
       sendRestore={admin.inbox.restoreCollection}

       asAcceptDecline={admin.collectionForm.asAcceptDecline}
       sendAccept={admin.inbox.acceptCollection}
       sendDecline={admin.inbox.declineCollection}
      />
    )
  }
}

const styles = theme => ({
  content: {
    width: '100%',
    overflow:'auto',
    overflowX:'hidden',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100% - 56px - 36px)',
    marginTop: 56 + 36,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px - 36px)',
      marginTop: 64 + 36,
    }
  },
  makeScrollable:{
    flex: '1 1 auto',
    display: 'inline-block',
    position: 'relative',
    'white-space': 'nowrap',
    'overflow-x': 'auto'
  }
})

LayoutAdmin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}


export default withStyles(styles, { withTheme: true })(withCookies(withRouter(LayoutAdmin)))



// WEBPACK FOOTER //
// ./src/components/admin/layoutadmin.js